import React, {useContext, useEffect, useState} from "react";
import {CreateDeliveryContext} from "../../../CreateDeliveryRequest";
import {OrderBlockContainer, OrderBlockHeader, OrderBlockTitle} from "./OrderBlock.styles";
import {CircleMarker} from "../../../../_defaultComponents/CircleMarker/CircleMarker";
import {InputRow} from "../../inputRow/InputRow";
import {Button, Col, Form, Input, Row, Select, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import {DeleteOutlined} from "@ant-design/icons";
import {GeoLocateSelect} from "../../../../_defaultComponents/GeoLocateSelect/GeoLocateSelect";
import {useStore} from "@vigo/hooks";
import {CityFilter} from "../../../../_defaultComponents/FilterComponents";
import CustomerSearchList from "./customerSearchList/CustomerSearchList";

export const OrderBlock = ({order, index, isLast = false, ...props}) => {
    const {
        createProduct,
        updateOrder,
        deleteOrder,
        getError,
        selectedSubCompany,
        paymentTypes,
        paymentTypesLoading
    } = useContext(CreateDeliveryContext);
    const [receiverCity, setReceiverCity] = useState(null);
    const {t} = useTranslation(["newRequest"]);
    const stores = useStore();
    const isDedicatedIntegration = stores.meStore?.pool?.integrationType === "dedicatedIntegration";

    useEffect(() => {
        if (selectedSubCompany?.city) {
            setReceiverCity(selectedSubCompany.city);
        }
    }, [selectedSubCompany]);

    return (
        <OrderBlockContainer isLast={isLast} {...props}>
            <OrderBlockHeader>
                <Row>
                    <CircleMarker color="gray">{index + 2}</CircleMarker>
                    <OrderBlockTitle>
                        {t("newRequest.fields.deliver", {ns: "newRequest"})}
                    </OrderBlockTitle>
                </Row>
                {order.index > 0 && (
                    <Tooltip title={t("newRequest.actions.removeOrder", {ns: "newRequest"})}>
                        <Button
                            onClick={() => deleteOrder({orderIndex: order?.index})}
                            icon={<DeleteOutlined />}
                        />
                    </Tooltip>
                )}
            </OrderBlockHeader>
            <InputRow
                title={t("fields.address", {ns: "common"})}
                content={
                    <>
                        <Form
                            autoComplete="off"
                            labelCol={{span: 24}}
                            wrapperCol={{span: 24}}
                            scrollToFirstError
                            data-testid="receviverForm"
                        >
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        validateStatus={
                                            getError(`orders.${order?.index}.receiverCity`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={getError(`orders.${order?.index}.receiverCity`)}
                                    >
                                        <CityFilter
                                            value={receiverCity}
                                            onChange={value => {
                                                setReceiverCity(value);
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverName: "",
                                                        receiverPhone: "",
                                                        receiverAddress: "",
                                                        receiverLocation: undefined,
                                                        receiverAddressDetail: ""
                                                    }
                                                });
                                            }}
                                            showAllOption={false}
                                            allowClear={true}
                                            ignoreCompanyCheck={true}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        validateStatus={
                                            !isDedicatedIntegration &&
                                            getError(`orders.${order?.index}.receiverAddress`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            !isDedicatedIntegration
                                                ? getError(`orders.${order?.index}.receiverAddress`)
                                                : null
                                        }
                                        style={{
                                            marginBottom:
                                                !isDedicatedIntegration &&
                                                getError(`orders.${order?.index}.receiverAddress`)
                                                    ? "20px"
                                                    : "0px"
                                        }}
                                    >
                                        <h5>
                                            {t("newRequest.fields.recipientAddress", {
                                                ns: "newRequest"
                                            })}
                                        </h5>
                                        <GeoLocateSelect
                                            name="receiverAddress"
                                            data-testid="receiverAddress"
                                            receiverCity={receiverCity}
                                            selectMarginBottom={
                                                !isDedicatedIntegration &&
                                                getError(`orders.${order?.index}.receiverAddress`)
                                                    ? "0px"
                                                    : "20px"
                                            }
                                            onChange={locationDetail =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverAddress:
                                                            locationDetail?.address || "",
                                                        receiverLocation: {
                                                            lon:
                                                                locationDetail.location
                                                                    ?.longitude || 0,
                                                            lat:
                                                                locationDetail.location?.latitude ||
                                                                0
                                                        }
                                                    }
                                                })
                                            }
                                            value={order?.receiverAddress}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span="24">
                                    <Form.Item validateStatus={false ? "error" : "success"}>
                                        <h5>{"Adres Tarifi"}</h5>
                                        <Input.TextArea
                                            rows={3}
                                            name={"receiverAddressDetail"}
                                            data-testid="receiverAddressDetail"
                                            value={order?.receiverAddressDetail}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverAddressDetail: e.target.value
                                                    }
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }
            />
            <InputRow
                title={t("newRequest.fields.recipient", {ns: "newRequest"})}
                content={
                    <>
                        <Form
                            autoComplete="off"
                            labelCol={{span: 24}}
                            wrapperCol={{span: 24}}
                            scrollToFirstError
                            data-testid="receviverForm"
                        >
                            <Row gutter={16}>
                                <Col span="24">
                                    <Form.Item
                                        validateStatus={
                                            getError(`orders.${order?.index}.receiverName`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={getError(`orders.${order?.index}.receiverName`)}
                                        style={{
                                            marginBottom: getError(
                                                `orders.${order?.index}.receiverName`
                                            )
                                                ? "10px"
                                                : "20px"
                                        }}
                                    >
                                        <h5>
                                            {t("newRequest.fields.recipientNameOrReceiptNumber", {
                                                ns: "newRequest"
                                            })}
                                        </h5>
                                        <CustomerSearchList
                                            fieldType="alphanumeric"
                                            placeholder="Müşteri adı / fiş numarası giriniz."
                                            name="receiverName"
                                            data-testid="receiverName"
                                            value={order?.receiverName}
                                            selectedSubCompanyId={selectedSubCompany?._id}
                                            required={true}
                                            onCustomerSelect={selectedCustomer => {
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverPhone:
                                                            selectedCustomer?.receiverPhone,
                                                        receiverName:
                                                            selectedCustomer?.receiverName,
                                                        receiverAddress:
                                                            selectedCustomer?.receiverAddress,
                                                        receiverLocation:
                                                            selectedCustomer?.receiverLocation,
                                                        receiverAddressDetail:
                                                            selectedCustomer?.receiverAddressDetail
                                                    }
                                                });
                                            }}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {...order, receiverName: e.target.value}
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span="24">
                                    <Form.Item
                                        validateStatus={
                                            !isDedicatedIntegration &&
                                            getError(`orders.${order?.index}.receiverPhone`)
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            !isDedicatedIntegration
                                                ? getError(`orders.${order?.index}.receiverPhone`)
                                                : null
                                        }
                                        style={{
                                            marginBottom:
                                                !isDedicatedIntegration &&
                                                getError(`orders.${order?.index}.receiverPhone`)
                                                    ? "10px"
                                                    : "20px"
                                        }}
                                    >
                                        <h5>
                                            {t("newRequest.fields.recipientPhone", {
                                                ns: "newRequest"
                                            })}
                                        </h5>
                                        <CustomerSearchList
                                            fieldType="phone"
                                            placeholder="0(555)-333-4444"
                                            mask="1(111)-111-1111"
                                            name="receiverPhone"
                                            data-testid="receiverPhone"
                                            value={order?.receiverPhone}
                                            selectedSubCompanyId={selectedSubCompany?._id}
                                            required={!isDedicatedIntegration}
                                            onCustomerSelect={selectedCustomer => {
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {
                                                        ...order,
                                                        receiverPhone:
                                                            selectedCustomer?.receiverPhone,
                                                        receiverName:
                                                            selectedCustomer?.receiverName,
                                                        receiverAddress:
                                                            selectedCustomer?.receiverAddress,
                                                        receiverLocation:
                                                            selectedCustomer?.receiverLocation,
                                                        receiverAddressDetail:
                                                            selectedCustomer?.receiverAddressDetail
                                                    }
                                                });
                                            }}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {...order, receiverPhone: e.target.value}
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span="24">
                                    <Form.Item validateStatus={false ? "error" : "success"}>
                                        <h5>
                                            {t("fields.orderNote", {
                                                ns: "common"
                                            })}
                                        </h5>
                                        <Input.TextArea
                                            rows={3}
                                            name={"note"}
                                            data-testid="note"
                                            value={order?.note}
                                            onChange={e =>
                                                updateOrder({
                                                    orderIndex: order?.index,
                                                    order: {...order, note: e.target.value}
                                                })
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }
            />
            {selectedSubCompany && (
                <>
                    <InputRow
                        title={"Ödeme Tipi"}
                        content={
                            <Form
                                autoComplete="off"
                                labelCol={{span: 24}}
                                wrapperCol={{span: 24}}
                                scrollToFirstError
                                data-testid="receviverForm"
                            >
                                <Form.Item
                                    validateStatus={
                                        getError(`orders.${order?.index}.paymentType`)
                                            ? "error"
                                            : "success"
                                    }
                                    help={getError(`orders.${order?.index}.paymentType`)}
                                    style={{
                                        marginBottom: getError(`orders.${order?.index}.paymentType`)
                                            ? "20px"
                                            : "0px"
                                    }}
                                >
                                    <Select
                                        style={{width: "100%"}}
                                        value={order?.paymentType}
                                        onChange={value => {
                                            updateOrder({
                                                orderIndex: order?.index,
                                                order: {
                                                    ...order,
                                                    paymentType: value
                                                }
                                            });
                                        }}
                                    >
                                        {paymentTypesLoading ? (
                                            <Select.Option value={null}>
                                                {"Yükleniyor..."}
                                            </Select.Option>
                                        ) : (
                                            paymentTypes?.codPaymentTypes?.map(paymentType => (
                                                <Select.Option
                                                    key={paymentType}
                                                    value={paymentType}
                                                >
                                                    {paymentType === "online"
                                                        ? "Online Ödeme"
                                                        : paymentType === "creditCard"
                                                        ? "Kredi Kartı"
                                                        : paymentType === "cash"
                                                        ? "Nakit"
                                                        : paymentType === "mealCard"
                                                        ? "Yemek Kartı"
                                                        : paymentType}
                                                </Select.Option>
                                            ))
                                        )}
                                    </Select>
                                </Form.Item>
                            </Form>
                        }
                    />
                    <InputRow
                        title={"Fiyat Bilgisi"}
                        content={
                            <Form
                                autoComplete="off"
                                labelCol={{span: 24}}
                                wrapperCol={{span: 24}}
                                scrollToFirstError
                                data-testid="receviverForm"
                            >
                                <Form.Item
                                    validateStatus={
                                        getError(`orders.${order?.index}.price`)
                                            ? "error"
                                            : "success"
                                    }
                                    help={getError(`orders.${order?.index}.price`)}
                                    style={{
                                        marginBottom: getError(`orders.${order?.index}.price`)
                                            ? "20px"
                                            : "0px"
                                    }}
                                >
                                    <Input
                                        placeholder="Fiyat Bilgisi Giriniz"
                                        style={{width: "100%"}}
                                        value={order?.price}
                                        onChange={e => {
                                            updateOrder({
                                                orderIndex: order?.index,
                                                order: {...order, price: e.target.value}
                                            });
                                        }}
                                    />
                                </Form.Item>
                            </Form>
                        }
                    />
                </>
            )}
            {/* <OrderBlockHeader>
                <Row style={{alignItems: "center"}}>
                    <Image width={30} src={productIcon} preview={false} />
                    <OrderBlockTitle>
                        {t("newRequest.fields.product", {ns: "newRequest"})}
                    </OrderBlockTitle>
                </Row>
            </OrderBlockHeader>
            {order.products.map((product, index) => (
                <ProductBlock
                    product={product}
                    index={index}
                    orderIndex={order.index}
                    key={index}
                />
            ))}
            <InputRow
                title=""
                content={
                    <>
                        <Button
                            onClick={() => createProduct({orderIndex: order?.index})}
                            style={{width: "100%"}}
                            icon={<PlusOutlined />}
                        >
                            {t("newRequest.actions.addProducts", {ns: "newRequest"})}
                        </Button>
                    </>
                }
            /> */}
        </OrderBlockContainer>
    );
};
